import React from "react";
import AnimationCommon from "../common/AnimationCommon";
import { Col, Container, Row } from "reactstrap";

const NotFound = () => {
  return (
    <section className='p-0'>
      <div className='auth-page error-main'>
        <Container>
          <Row>
            <Col sm='12'>
              <div className='text-center'>
                <h2 className='error-font'>
                  4<span>0</span>4
                </h2>
                <h2 className='f-bold'>Oops! Error 404 not found.</h2>
                <Col lg='8' xs='12' className='offset-lg-2'>
                  <h4>The page you were looking for doesn't exist. We think the page may have moved. </h4>
                </Col>
              </div>
            </Col>
          </Row>
        </Container>
        <AnimationCommon />
      </div>
    </section>
  );
};

export default NotFound;
